<template>
  <v-card flat>
    <!-- {{ item }} -->
    <v-card-title class="text-wrap font-weight-bold">{{ item.name }}</v-card-title>
    <v-card-text class="black--text">
      <div>
        <div class="body-1 font-weight-bold">Summary:</div>
        <div class="d-flex justify-space-between">
          <div style="width:150px">
            {{ item.name }}
          </div>
          <span>
            <span v-html="MIXIN_PESO_SIGN"></span> {{ item.amount | numFormat('0,0.00') }}
          </span>
        </div>
        <div class="d-flex justify-space-between">
          <div>
            Discount
          </div>
          <span>
            <span v-html="MIXIN_PESO_SIGN"></span> {{ item.discount | numFormat('0,0.00') }}
          </span>
        </div>
        <div class="d-flex justify-space-between">
          <div>
            Discounted Total
          </div>
          <span>
            <span v-html="MIXIN_PESO_SIGN"></span> {{ discountAmount | numFormat('0,0.00') }}
          </span>
        </div>
        <div class="d-flex justify-space-between">
          <div>
            12% value added tax (VAT)	
          </div>
          <span>
            <span v-html="MIXIN_PESO_SIGN"></span> {{ amountVAT | numFormat('0,0.00') }}
          </span>
        </div>
        <v-divider></v-divider>
        <div class="d-flex justify-space-between">
          <div>
            Total Cost
          </div>
          <span>
            <span v-html="MIXIN_PESO_SIGN"></span> {{ totalAmount | numFormat('0,0.00') }}
          </span>
        </div>
      </div>
      <div class="mt-5 body-1 font-weight-bold">Overview:</div>
      <div class="font-weight-light pre-wrap px-5 description">
        {{ item.description }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  computed: {
    amountVAT: function() {
      return this.discountAmount * 0.12;
    },
    discountAmount: function() {
      let discount = this.item.discount || 0;
      return this.item.amount - discount;
    },
    totalAmount: function() {
      return this.discountAmount + this.amountVAT;
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>